import { HEADERS_JSON } from "@/common/api/config";
import { CommonResponse } from "@/common/api/types";
import { catchError } from "@/common/api/utils";
import { GATEWAY_URL } from "@/common/config";
import {
  CabinetResponse,
  SmsCheckUpdateRequest,
  SmsSendUpdateRequest,
  SmsSendUpdateResponse,
} from "@/entities/cabinet/api/types";

export const fetchCabinetStatus = async (
  token: string,
): Promise<CabinetResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/cabinet/information?token=${token}`,
    {
      method: "GET",
      headers: HEADERS_JSON,
    },
  );
  catchError(response);
  return await response.json();
};

export const postSmsSendUpdate = async ({
  token,
  data,
}: {
  token: string;
  data: SmsSendUpdateRequest;
}): Promise<SmsSendUpdateResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/cabinet/bmg-update/sms-send?token=${token}`,
    {
      method: "POST",
      headers: HEADERS_JSON,
      body: JSON.stringify(data),
    },
  );
  catchError(response);
  return await response.json();
};

export const postSmsCheckUpdate = async ({
  token,
  data,
}: {
  token: string;
  data: SmsCheckUpdateRequest;
}): Promise<CommonResponse> => {
  const response = await fetch(
    `${GATEWAY_URL}/cabinet/bmg-update/sms-check?token=${token}`,
    {
      method: "POST",
      headers: HEADERS_JSON,
      body: JSON.stringify(data),
    },
  );
  catchError(response);
  return await response.json();
};
